import styled from "styled-components";

export const ContainerSchedules = styled.div`
    border: 1px solid #b9c0c9;
    border-radius: 4px;
    padding: 5px;
    width: 100%;
    margin: 10px 0px;
    display: grid;
    grid-template-columns:  1fr 1fr;
    column-gap: 10px;
    row-gap: 6px;
`;

export const Schedule = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns:  6fr 3fr 2fr 1fr;

    background-color: ${({ theme }) => theme.colors.backgroundSecondary};
    padding: 6px 12px;
    border-radius: 6px;
`

export const ScheduleField = styled.div`
    color: ${({ theme }) => theme.colors.text};
`;

export const IconWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
    width: 100%;
    height: 100%;
    padding: 0 8px;
    
    color: ${({ theme }) => theme.colors.text};
`;

export const Title = styled.span`
    color: ${({ theme }) => theme.colors.text};
    font-size: 16px;
`;

export const Column = styled.div` 
  display: flex;
  flex-direction: column;
  flex: 1;
`; 

export const Row = styled.div`
    display: flex;
    gap: 20px;
    width: 100%;
`;